<template>
    <v-app>
        <v-main>
            <headerBottomVue />

            <v-card
                class="mx-auto"
                max-width="1380"
                v-if="$store.state.searchData.isSearchResult == true"
            >
                <searchvue />
            </v-card>
            <v-card
                class="mx-auto"
                max-width="1380"
                v-if="$store.state.searchData.isSearchResult == false"
            >
                <!--breadcrumbs-->
                <v-container d-flex flex-row style="border: 0px solid red">
                    <v-row>
                        <v-col cols="12" md="10" xs="12">
                            <v-breadcrumbs class="pa-4 mt-0" id="breadcrumbs">
                                <v-breadcrumbs-item
                                    v-for="itemURL in this.urlArray"
                                    :key="itemURL.text"
                                >
                                    <a
                                        style="
                                            color: black;
                                            font-weight: normal;
                                        "
                                        v-bind:href="baseUrl + itemURL.url"
                                        :aria-label="itemURL.text"
                                    >
                                        {{ mainCategory(itemURL.text) }}</a
                                    >
                                    <v-icon
                                        v-if="ismainCategory == false"
                                        class="ml-2"
                                        >mdi-dots-vertical</v-icon
                                    >
                                </v-breadcrumbs-item>
                                <v-breadcrumbs-item>
                                    <b>{{ this.categoryName }}</b>
                                </v-breadcrumbs-item>
                            </v-breadcrumbs>
                        </v-col>
                        <!--universityApp-->
                        <universityappvue
                            v-if="
                                this.categoryName == 'Student' ||
                                    this.categoryName == 'Uczelnia' ||
                                    this.categoryName ==
                                        'Biblioteka Uczelniana' ||
                                    this.categoryName ==
                                        'Dział Praktyk Studenckich i Karier'
                            "
                        />
                        <!--universityApp-->
                        <v-col
                            cols="6"
                            md="1"
                            xs="6"
                            v-if="
                                this.categoryName == 'Student' ||
                                    this.categoryName == 'Uczelnia' ||
                                    this.categoryName ==
                                        'Biblioteka Uczelniana' ||
                                    this.categoryName ==
                                        'Dział Praktyk Studenckich i Karier'
                            "
                        >
                            <v-btn
                                aria-label="Serwisy Akademii Nauk Stosowanych Angelusa Silesiusa"
                                class="mt-2"
                                outlined
                                color="red darken-5"
                                @click.stop="
                                    $store.state.UniversityAppData.universityApp = !$store
                                        .state.UniversityAppData.universityApp
                                "
                            >
                                <v-icon>mdi-open-in-app</v-icon>
                                Serwisy ANS AS
                            </v-btn>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2"
                            xs="6"
                            class="hidden-md-and-up text-left pr-6"
                        >
                            <v-btn
                                class="mt-1"
                                icon
                                light
                                large
                                @click.stop="drawer = !drawer"
                            >
                                <v-app-bar-nav-icon
                                    aria-label="Menu"
                                ></v-app-bar-nav-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                <!--breadcrumbs-->
                <!--mobile menu-->
                <div v-if="this.isMenu == true" class="hidden-md-and-up ma-3">
                    <v-navigation-drawer
                        :width="380"
                        :height="600"
                        v-model="drawer"
                        absolute
                    >
                        <sidebar-menu
                            class="pa-3 sidebar mt-3 hidden-md-and-up ma-3"
                            :menu="menu"
                            :hideToggle="true"
                            :relative="true"
                            @item-click="loadPostData"
                        >
                            <div id="headerMenu" slot="header">
                                <v-row no-gutters>
                                    <v-col class="col1 pa-2 col-2 red darken-5">
                                        <v-btn
                                            icon
                                            dark
                                            :href="defaulthref"
                                            aria-label="Przejdź do strony głównej"
                                        >
                                            <v-icon class="pl-1"
                                                >mdi-home</v-icon
                                            >
                                        </v-btn>
                                    </v-col>
                                    <v-col
                                        class="col2 pt-2 pl-3 col-10 red darken-5"
                                    >
                                        <v-btn
                                            depressed
                                            text
                                            dark
                                            :href="'/' + this.categorySlug"
                                        >
                                            {{ this.mainCategoryName }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                            <template v-slot:footer>
                                <v-col row class="red darken-5"> </v-col>
                            </template>
                        </sidebar-menu>
                    </v-navigation-drawer>
                </div>
                <!--mobile menu-->
                <!-- menu-->
                <v-container d-flex flex-row>
                    <sidebar-menu
                        v-if="this.isMenu == true"
                        elevation="3"
                        class="sidebar mt-3 hidden-md-and-down ma-3"
                        :menu="menu"
                        :showOneChild="true"
                        :hideToggle="true"
                        :relative="true"
                    >
                        <template v-slot:footer>
                            <v-col row class="col2 col-12 red darken-5">
                            </v-col>
                        </template>
                        <div id="headerMenu" slot="header">
                            <v-row no-gutters>
                                <v-col class="col1 pa-2 col-2 red darken-5">
                                    <v-btn
                                        icon
                                        dark
                                        :href="defaulthref"
                                        aria-label="Przejdź do strony głównej"
                                    >
                                        <v-icon class="pl-1">mdi-home</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col
                                    class="col2 pt-4 pl-0 col-10 red darken-5"
                                >
                                    <a
                                        style="
                                            color: white;
                                            text-decoration: none;
                                            font-weight: normal;
                                        "
                                        v-bind:href="'/' + this.categorySlug"
                                        :aria-label="this.mainCategoryName"
                                    >
                                        {{ this.mainCategoryName }}</a
                                    >
                                </v-col>
                            </v-row>
                        </div>
                    </sidebar-menu>

                    <!-- end menu-->
                    <v-main>
                        <v-container v-if="isLoading">
                            <v-progress-linear
                                color="blue darken-4"
                                indeterminate
                                height="6"
                            >
                            </v-progress-linear>
                            <v-col>
                                <v-skeleton-loader
                                    type="list-item-three-line, card-heading, image"
                                ></v-skeleton-loader>
                            </v-col>
                        </v-container>

                        <v-container v-if="isError">
                            <v-progress-linear
                                color="blue darken-4"
                                indeterminate
                                height="6"
                            >
                            </v-progress-linear>

                            <v-card color="primary">
                                <v-card-title>Error</v-card-title>
                                <v-fade-transition
                                    >Błąd nr 500</v-fade-transition
                                >
                            </v-card>
                        </v-container>
                    </v-main>
                    <!-- post detail-->
                    <v-container v-if="isLoading == false">
                        <div v-if="isNews == true">
                            <newsinstitutevue />
                        </div>
                        <div id="post" v-if="isNews == false">
                            <section aria-labelledby="headerMenu">
                                <h1
                                    id="headerMenu"
                                    class="text-left mb-2"
                                    v-html="this.itemData.title"
                                ></h1>
                            </section>
                            <v-img
                                class="mb-6"
                                v-if="isfeaturedImage == true"
                                :aspect-ratio="16 / 9"
                                max-height="640px"
                                :src="'/uploads/' + itemData.featuredImage"
                                :alt="this.itemData.altText"
                                :aria-label="this.itemData.altText"
                            ></v-img>
                            <div
                                id="post"
                                v-html="this.itemData.post"
                                class=""
                            ></div>
                            <div v-if="isRecruiting == true">
                                <courseofstudyvue />
                            </div>

                            <v-spacer></v-spacer>
                            <div v-if="this.isAttachment == true">
                                <v-divider></v-divider>
                                <h3>Dokumenty do pobrania</h3>
                            </div>

                            <v-list-item
                                v-for="attachItem in itemData.attach"
                                :key="attachItem.id"
                            >
                                <v-list-item-avatar>
                                    <v-icon class="blue darken-5" dark small>
                                        mdi-attachment</v-icon
                                    >
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title
                                        class="text-wrap"
                                        v-text="
                                            attachItem.description +
                                                ' (dokument ' +
                                                attachItem.extension +
                                                ', rozmiar ' +
                                                attachItem.size +
                                                ')'
                                        "
                                    >
                                    </v-list-item-title>
                                </v-list-item-content>

                                <v-btn
                                    class="blue darken-5"
                                    dark
                                    :aria-label="
                                        'Pobierz ' +
                                            attachItem.description +
                                            'dokument ' +
                                            attachItem.extension +
                                            ', rozmiar ' +
                                            attachItem.size
                                    "
                                    @click="
                                        downloadFile(
                                            attachItem.id,
                                            attachItem.filename,
                                            attachItem.extension
                                        )
                                    "
                                >
                                    <v-icon> mdi-download-outline </v-icon>
                                </v-btn>
                            </v-list-item>
                        </div>
                    </v-container>
                    <!-- end post detail-->
                </v-container>
            </v-card>
        </v-main>
        <footerBlueVue />
    </v-app>
</template>

<script>
import headerBottomVue from "../HeaderBottom.vue";
import searchvue from "../../components/Search.vue";
import courseofstudyvue from "../../components/CourseOfStudy.vue";
import newsinstitutevue from "../../components/pages/newsInstitute.vue";
import universityappvue from "../../components/UniversityApp.vue";
import footerBlueVue from "../FooterBlue.vue";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import { bootstrap } from "vue-gtag";

export default {
    components: {
        headerBottomVue,
        newsinstitutevue,
        searchvue,
        courseofstudyvue,
        universityappvue,
        footerBlueVue
    },

    data() {
        return {
            baseUrl: window.location.origin,
            itemIsArray: false,

            drawer: null,
            //  universityApp: false,

            menu: [],
            isError: false,
            isLoading: true,
            isfeaturedImage: false,
            isAttachment: false,
            categorySlug: "",
            lastSegmentCategorySlug: "",
            categoryList: [],
            categoryName: "",
            itemData: [{ title: null, attach: null }],
            breadcrumbsItems: [],
            defaulthref: "/",
            ismainCategory: true,
            mainCategoryName: "",
            isChildren: [],
            isTsc: false,
            file_id: "",
            filename: "",
            isNews: false,
            isRecruiting: false,
            isMenu: true,
            isSubcategory: false,
            isAllowGA: false,
            urlArray: []
        };
    },

    methods: {
        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", this.filename); //or any other extension
            link._target = "blank";
            document.body.appendChild(link);
            link.click();
        },

        async downloadFile(file_id, description, ext) {
            this.filename = description + "." + ext;
            if (this.isAllowGA == true) {
                bootstrap().then(gtag => {
                    this.$gtag.event("click", {
                        event_category: "buttons",
                        event_action: "download file",
                        event_label: this.filename
                    });
                });
            }

            axios({
                method: "get",
                url: `/file/download/${file_id}`,
                responseType: "arraybuffer"
            })
                .then(response => {
                    this.forceFileDownload(response);
                })
                .catch(() => console.log("error occured"));
        },

        mainCategory(text) {
            if (text == this.categoryName) {
                this.mainCategoryName = this.categoryName;
                this.ismainCategory = true;
            } else {
                this.ismainCategory = false;
                return text;
            }
        },

        existfeaturedImage(image) {
            if (image) {
                this.isfeaturedImage = true;
            } else {
                this.isfeaturedImage = false;
            }
        },

        async categoryHasChildren(categorySlug) {
            const [postData] = await Promise.all([
                this.callApi("get", `/tsc/${categorySlug}`)
            ]);
            if (postData.status == 200) {
                if (postData.data == 0) {
                    this.getPostData(categorySlug);
                    this.isTsc = postData.data;
                } else {
                    this.isTsc = postData.data;
                }
                if (typeof postData.data === "undefined") {
                    console.log("id is undefined...");
                    this.isLoading = true;
                    this.isError - true;
                }
            }
        },

        async getMainPost(categoryDetail, categorySlug) {
            const [postData] = await Promise.all([
                this.callApi("get", `/tsc/${categoryDetail}`)
            ]);

            if (postData.status == 200) {
                if (postData.data == 0) {
                    this.getPostData(categoryDetail);
                } else {
                    /*if is subcategory then get maincategory */
                    this.getPostData(categorySlug);
                }
            } else if (postData.status == 500) {
                this.isError - true;
            }
        },

        getFirstUrlSegment(urlSlug) {
            let firstUrlSegment, urlSlugReverse;
            urlSlugReverse = urlSlug.split("/");
            firstUrlSegment = urlSlugReverse.reverse().pop();
            return firstUrlSegment;
        },

        getLastUrlSegment(urlSlug) {
            let lastUrlSegment;
            lastUrlSegment = urlSlug.split("/").pop();
            return lastUrlSegment;
        },

        async getPostData(categoryDetail) {
            const [postData] = await Promise.all([
                this.callApi("get", `/details/${categoryDetail}`)
            ]);

            if (postData.status == 200) {
                this.isLoading = false;
                if (Array.isArray(postData.data.postData.cat) === true) {
                    //console.log('postData.data.postData.cat[0].categoryType', postData.data.postData.cat[0].categoryType)
                    if (postData.data.postData.cat[0].categoryType == 10) {
                        this.isRecruiting = true;
                        const categoryTypeObj = {
                            categoryName: postData.data.postData.categoryName,
                            categoryType:
                                postData.data.postData.cat[0].categoryType
                        };

                        this.$store.commit(
                            "setCategoryTypeData",
                            categoryTypeObj
                        );
                    } else {
                        this.isRecruiting = false;
                    }

                    if (
                        postData.data.postData.cat[0].categoryType == 4 ||
                        postData.data.postData.cat[0].categoryType == 5 ||
                        postData.data.postData.cat[0].categoryType == 6 ||
                        postData.data.postData.cat[0].categoryType == 7 ||
                        postData.data.postData.cat[0].categoryType == 8 ||
                        postData.data.postData.cat[0].categoryType == 9
                    ) {
                        this.isNews = true;
                        const categoryTypeObj = {
                            categoryName: postData.data.postData.categoryName,
                            categoryType:
                                postData.data.postData.cat[0].categoryType
                        };
                        this.$store.commit(
                            "setCategoryTypeData",
                            categoryTypeObj
                        );
                    } else {
                        this.isNews = false;
                    }
                }

                this.categoryName = postData.data.postData.categoryName;
                document.title = this.categoryName + " - ans.edu.pl";
                this.itemData.title = postData.data.postData.title;
                this.itemData.featuredImage =
                    postData.data.postData.featuredImage;
                this.existfeaturedImage(postData.data.postData.featuredImage);
                this.itemData.altText = postData.data.postData.altText;
                this.itemData.post = postData.data.postData.post;
                this.itemData.tag = postData.data.postData.tag;
                this.itemData.cat = postData.data.postData.cat;
                this.itemData.attach = postData.data.postAttach.sort(
                    (a, b) => b.position - a.position
                );
                this.breadcrumbsItems = postData.data.postData.url;

                let myArray = postData.data.postData.url;
                let maxElement = myArray.length;

                let step = 0;
                let myurl = "";
                this.urlArray = [];
                for (step = 0; step < maxElement; step++) {
                    myurl = myurl + "/" + myArray[step].href;
                    this.urlArray.push({
                        url: myurl,
                        text: myArray[step].text
                    });
                }

                if (postData.data.postAttach) {
                    if (postData.data.postAttach.length > 0) {
                        this.isAttachment = true;
                    } else {
                        this.isAttachment = false;
                    }
                }
                if (Array.isArray(postData.data.postData.cat) === true) {
                    this.mainCategoryName = postData.data.postData.url[0].text;
                }
            }
        },

        async loadPostData(e, i) {
            this.drawer = true;
            this.isSubcategory = false;
            if (Array.isArray(i.child) === false) {
                this.drawer = false;
                this.isError = false;
                this.isLoading = true;
            } else {
                this.isSubcategory = true;
            }
        }
    },

    watch: {
        $route(to, from) {
            this.categoryHasChildren(this.getLastUrlSegment(to.path));
        }
    },

    async created() {
        const [res] = await Promise.all([this.callApi("get", "get_cookie")]);
        if (res.status == 200) {
            if (res.data == 1) {
                //console.log("cookies is allow");
                this.isAllowGA = true;
            } else {
                //  console.log("not cookies ", res.data);
            }
        }

        this.categorySlug = this.getFirstUrlSegment(
            this.$route.params.categorySlug
        );

        this.categoryDetail = this.$route.path
            .substring(1)
            .split("/")
            .pop();

        const [menuData] = await Promise.all([
            this.callApi("get", `/menu/${this.categorySlug}`)
        ]);
        if (menuData.status == 200) {
            if (menuData.data !== null) {
                if (menuData.data.length > 0) {
                    this.menu = menuData.data;
                } else {
                    menuData.data;
                    this.isMenu = false;
                }
            }
            this.getMainPost(this.categoryDetail, this.categorySlug);
        }
    }
};
</script>

<style scoped>
#post >>> table {
    border-collapse: collapse;
    width: 100%;
    margin: 20px 0;
}

#post >>> th {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
}
#post >>> td {
    border-bottom: 1px solid #ddd;
    padding: 8px;
    text-align: left;
}

#post >>> th {
    background-color: #f0f0f0;
    font-weight: bold;
}

@media (max-width: 600px) {
    #post >>> table {
        font-size: 14px;
    }
}

#post >>> iframe {
    border: 15px solid #f5f5f5;
    width: 100%;
    min-height: 640px;
    min-height: 720px;
}

#post {
    overflow-wrap: break-word;
}

#post >>> p {
    line-height: 1.5em;
    padding: 0px;
}

#post >>> hr {
    margin: 5px 0px 5px 0px;
    color: #e9e9e9;
    border: 1px solid #e9e9e9;
}

#post >>> h1 {
    text-transform: uppercase;
    color: black;
    border-left: 0px solid #c20444;
    border-bottom: 1px solid #c20444;
    font-weight: normal;
    padding: 10px 0px 5px 5px;
    margin: 0px 0px 5px 0px;
    font-size: 1.8em;
}

#post >>> h2 {
    color: #0e3d85;
    border-left: 0px solid #0e3d85;
    border-bottom: 0px solid #0e3d85;
    font-weight: 600;
    padding: 5px 0px 5px 5px;
    margin: 0px 0px 5px 0px;
    font-size: 1.4em;
}

#post >>> h3 {
    border-left: 0px solid #2e62ad;
    border-bottom: 0px solid #2e62ad;
    color: black;
    /*background: #05355a;
    font-weight: normal;*/
    font-weight: 600;
    padding: 5px 0px 5px 5px;
    margin: 0px 0px 5px 0px;
    font-size: 1em;
}

#post >>> li {
    margin-left: 1em;
}

.attach {
    background: #0e3d85;
}
/*
#post >>> table tr td ol ul {
    margin-top: 0px;
}
*/

/*
#post >>> table li {
    margin-left: 0px;
}

#post >>> ul ol {
    margin-top: -20px;
}

#post >>> li {
    margin-left: 2.5em;
    padding: 2px;
}

#post >>> li:first-child {
    border: 0px solid red;
    margin-top: 0px;
}

*/

/*
#post >>> tr td {
    padding: 10px;
}
*/
#breadcrumbs {
    margin: 0px 15px 0px 0px;
    padding: 10px;
    background: #f5f5f5;
}

#headerMenu {
    color: white;
    font-weight: bold;
    overflow-wrap: break-word;
    min-height: 50px;
    text-transform: uppercase;
}
</style>
